import React, { Component } from "react";
import styles from "./logisticAlatmTool.module.scss";

class AlarmDayButton extends Component {
  render() {
    const { isCheck, day, title, dayClick } = this.props;

    return (
      <div
        className={isCheck ? styles.logisticaDayCircleContainerChekced : styles.logisticaDayCircleContainer}
        onClick={() => {
          dayClick(day, !isCheck);
        }}
      >
        {title}
      </div>
    );
  }
}

export default React.memo(AlarmDayButton);
